import React, { ChangeEvent, FC } from "react";

interface TextAreaFieldProps {
    label?: string;
    value?: string;
    placeholder?: string;
    onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    className?: string;
    required?: boolean;
    name?: string;
    rows?: number;
    hidelabel?: boolean;
    labelClassName?:string,
    disabled?:any
}

const TextAreaField: FC<TextAreaFieldProps> = ({
    label,
    value,
    placeholder = "",
    required = false,
    onChange,
    className = "",
    name,
    rows = 3,
    hidelabel = false,
    labelClassName = '',
    disabled
}) => {
    return (
        <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
            {!hidelabel && (
                <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                    <div className={`text-surface-0 ${labelClassName}`}>
                        {required ? `*${label}` : label}
                    </div>
                </div>
            )}
            <div className={hidelabel ? "col-span-12" : "col-span-9"}>
                <textarea
                    name={name}
                    className={`rounded-md border border-surface-5 form_control p-2 w-full mt-2 bg-text-0 ${className}`}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    rows={rows}
                    readOnly={disabled}
                    required={required}
                />
            </div>
        </div>
    );
};

export default TextAreaField;
